<form>
	<div class="row">
		<div class="col-md-4 mb-3">
			<label class="form-label" for="id">Numer rezerwacji</label>
			<div class="col">
				<input type="number" class="form-control" name="id" [(ngModel)]="filters.id" />
			</div>
		</div>
		<div class="col-md-4">
			<div class="row">
				<label class="form-label" for="created_at">Data utworzenia rezerwacji</label>
				<div class="col-md-6">
					<input
						id="reservation_time__gte"
						class="form-control"
						name="reservation_time__gte"
						[(ngModel)]="parseFilters.reservation_time__gte"
						type="date"
					/>
				</div>
				<div class="col-md-6">
					<input
						id="reservation_time__lte"
						class="form-control"
						name="reservation_time__lte"
						[(ngModel)]="parseFilters.reservation_time__lte"
						type="date"
					/>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="payment_status"
				[(ngModel)]="filters.payment_status"
				[multiple]="true"
				(change)="onPaymentStatusChange()"
				placeholder="Status płatności"
			>
				@for (item of paymentStatus; track $index) {
					<ng-option [value]="item.name">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row">
		<div class="col-md-4 mb-3">
			<div class="row">
				<label class="form-label" for="created_at">Klient</label>
				<div class="col-md-12">
					<input
						type="text"
						[(ngModel)]="filters.owner_name"
						name="owner_name"
						id="owner_name"
						class="form-control"
					/>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<div class="row">
				<label class="form-label" for="confirmation_time">Data potwierdzenia</label>
				<div class="col-md-6">
					<input
						id="confirmation_time__gte"
						class="form-control"
						name="confirmation_time__gte"
						[(ngModel)]="parseFilters.confirmation_time__gte"
						type="date"
					/>
				</div>
				<div class="col-md-6">
					<input
						id="confirmation_time__lte"
						class="form-control"
						name="confirmation_time__lte"
						[(ngModel)]="parseFilters.confirmation_time__lte"
						type="date"
					/>
				</div>
			</div>
		</div>

		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="channel"
				[(ngModel)]="filters.channel"
				[multiple]="true"
				placeholder="Kanał sprzedaży"
			>
				@for (item of channels; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>

	<div class="row">
		<div class="col-md-4 mb-3">
			<div class="row">
				<label class="form-label" for="created_at">Numer telefonu</label>
				<div class="col-md-12">
					<input
						type="text"
						[(ngModel)]="filters.owner_phone"
						name="owner_phone"
						id="owner_phone"
						class="form-control"
					/>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<div class="row">
				<label class="form-label">Data rozpoczęcia</label>
				<div class="col-md-6">
					<input
						id="time_before"
						class="form-control"
						name="time_lower_after"
						[(ngModel)]="parseFilters.time_lower_after"
						type="date"
					/>
				</div>
				<div class="col-md-6">
					<input
						id="time_after"
						class="form-control"
						name="time_lower_before"
						[(ngModel)]="parseFilters.time_lower_before"
						type="date"
					/>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="seller_in"
				[(ngModel)]="filters.seller"
				[multiple]="true"
				[closeOnSelect]="false"
				placeholder="Agent"
			>
				@for (item of agencies; track item.id) {
					<ng-option [value]="item.id">{{ item.shortName }}</ng-option>
				}
			</ng-select>
		</div>
	</div>

	<div class="row mb-3">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="product"
				[(ngModel)]="filters.product"
				[multiple]="true"
				placeholder="Produkt"
			>
				@for (item of products; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<label class="form-label">Data zakończenia</label>
			<div class="row">
				<div class="col-md-6">
					<input
						id="time_before"
						class="form-control"
						name="time_upper_after"
						[(ngModel)]="parseFilters.time_upper_after"
						type="date"
					/>
				</div>
				<div class="col-md-6">
					<input
						id="time_after"
						class="form-control"
						name="time_upper_before"
						[(ngModel)]="parseFilters.time_upper_before"
						type="date"
					/>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="responsible_user"
				[(ngModel)]="filters.responsible_user"
				[multiple]="true"
				placeholder="Opiekun"
			>
				@for (item of users; track item.id) {
					<ng-option [value]="item.id">{{ item.firstName }} {{ item.lastName }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="product_kind"
				[(ngModel)]="filters.product_kind"
				[multiple]="true"
				placeholder="Typ produktu"
			>
				@for (item of productKinds; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<label class="form-label" for="total_price">Wartość rezerwacji</label>
			<div class="row">
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							[(ngModel)]="parseFilters.total_price_min"
							name="total_price_min"
							id="total_price_min"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							id="total_price_max"
							[(ngModel)]="parseFilters.total_price_max"
							name="total_price_max"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="alert"
				[(ngModel)]="filters.alert"
				[multiple]="true"
				placeholder="Alerty"
			>
				@for (item of alerts; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				placeholder="Typ rezerwacji"
				name="seller_is_oskar"
				[(ngModel)]="filters.seller_is_oskar"
			>
				<ng-option [value]="Seller.IS_NOT_OSKAR">Agencyjna</ng-option>
				<ng-option [value]="Seller.IS_OSKAR">Nieagencyjna</ng-option>
				<ng-option [value]="Seller.ALL">Wszystkie</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<label class="form-label" for="balance_without_commission">Pozostało do zapłaty (bez prowizji)</label>
			<div class="row">
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							[(ngModel)]="parseFilters.balance_without_commission_max"
							name="balance_without_commission_max"
							id="balance_without_commission_max"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							id="balance_without_commission_min"
							[(ngModel)]="parseFilters.balance_without_commission_min"
							name="balance_without_commission_min"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="status"
				[(ngModel)]="parseFilters.status"
				[multiple]="true"
				placeholder="Status"
			>
				@for (item of status; track item.id) {
					<ng-option [value]="item.id">{{ item.id }} | {{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="departure_city"
				[(ngModel)]="filters.departure_city"
				[multiple]="true"
				placeholder="Miasto wyjazdu"
			>
				@for (item of locations; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<label class="form-label" for="balance">Pozostało do zapłaty</label>
			<div class="row">
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							[(ngModel)]="parseFilters.balance_min"
							name="balance_min"
							id="balance_min"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							[(ngModel)]="parseFilters.balance_max"
							id="balance_max"
							name="balance_max"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="offer__status"
				[(ngModel)]="parseFilters.offer__status"
				[multiple]="true"
				placeholder="Status ofert"
			>
				@for (item of status; track item.id) {
					<ng-option [value]="item.id">{{ item.id }} | {{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="destination_location"
				[(ngModel)]="filters.destination_location"
				[multiple]="true"
				placeholder="Destynacja"
			>
				@for (item of destinations; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="room_type"
				[(ngModel)]="filters.room_type"
				[multiple]="true"
				placeholder="Typ pokoju"
			>
				@for (item of roomTypes; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<label class="form-label" for="balance_without_commission">Suma płatności</label>
			<div class="row">
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							[(ngModel)]="parseFilters.paid_amount_min"
							name="paid_amount_min"
							id="paid_amount_min"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="number"
							id="paid_amount_max"
							[(ngModel)]="parseFilters.paid_amount_max"
							name="paid_amount_max"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-md-4">
			<label class="form-label" for="nights_min">Il. nocy</label>
			<div class="row">
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="text"
							[(ngModel)]="filters.nights_min"
							name="nights_min"
							id="nights_min"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-outline">
						<input
							type="text"
							id="nights_max"
							[(ngModel)]="filters.nights_max"
							name="nights_max"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				placeholder="Wyrównanie"
				name="price_adjusted"
				[(ngModel)]="filters.price_adjusted"
			>
				<ng-option [value]="PriceAdjustmentReservations.NO_PRICE_ADJUSTMENT">Bez wyrównania</ng-option>
				<ng-option [value]="PriceAdjustmentReservations.PRICE_ADJUSTMENT">Wyrównanie</ng-option>
				<ng-option [value]="PriceAdjustmentReservations.ALL">Wszystkie</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				appendTo="body"
				name="service"
				[(ngModel)]="filters.service"
				[multiple]="true"
				placeholder="Usługi"
			>
				@for (item of services; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row mb-3 justify-content-md-end">
		<div class="col-md-4 mb-3">
			<label class="form-label" for="voucher">Voucher</label>
			<div class="col mb-2">
				<input type="text" class="form-control" name="voucher" [(ngModel)]="filters.voucher" />
			</div>
			<ng-select
				appendTo="body"
				name="transport_types"
				[(ngModel)]="filters.transport_types"
				[multiple]="true"
				placeholder="Typ transportu"
			>
				@for (item of transportTypesOptions; track item.code) {
					<ng-option [value]="item.code">
						<i class="fa-solid me-2" [ngClass]="item.code | transportKindIcon"></i>
						{{ item.label }}
					</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="payment_kind"
				[(ngModel)]="filters.payment_kind"
				[multiple]="true"
				placeholder="Rodzaj płatności"
			>
				@for (item of paymentKinds(); track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				appendTo="body"
				name="organization"
				[(ngModel)]="filters.organization"
				[multiple]="true"
				placeholder="Organizator"
			>
				@for (item of organizations; track item.id) {
					<ng-option [value]="item.id">{{ item.shortName }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
	<div class="row mb-3 justify-content-md-end">
		<div class="col-md-4">
			<ng-select appendTo="body" name="season" [(ngModel)]="filters.season" [multiple]="true" placeholder="Sezon">
				@for (item of seasons; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
	</div>
</form>
<div class="button-row">
	<button class="me-3" mat-raised-button (click)="filtersClear()">Wyczyść</button>
	<button class="me-3" mat-raised-button (click)="filtersDefault()">Ustaw jako domyślne</button>
	<button class="me-3 mat-primary-button" color="primary" mat-raised-button (click)="filtersSave()">Pokaż</button>
	<section class="example-section">
		<mat-checkbox
			[disabled]="statsDisabled"
			class="example-margin me-3"
			color="primary"
			[(ngModel)]="showStatistic.show"
			>Pokaż statystyki</mat-checkbox
		>
		@if (statsDisabled) {
			<i
				matTooltip="Tymczasowo statystyki są dostępne tylko dla maksymalnie rezerwacji z jednego miesiąca. Użyj odpowiednich filtrów."
				class="fa fa-circle-info"
			></i>
		}
	</section>
</div>
